const decorator = str => 'cart-page/' + str;


export const ADDRESS_FORM_MODIFIED = decorator('ADDRESS_FORM_MODIFIED');
export const ADDRESS_FORM_MODIFICATION_HANDLED = decorator('ADDRESS_FORM_MODIFICATION_HANDLED');
export const RESET_CART_PAGE = decorator('RESET_CART_PAGE');
